import { useAuthStore } from '@modules/auth/stores/auth.store.js'
import { ADMIN_ROLES } from '@/core/constants/allowed-roles.constant'

export function axiosInterceptorAdministrator(axiosInstance) {
  axiosInstance.interceptors.request.use(
    (config) => {
      const authStore = useAuthStore()
      const roles = authStore.userRoles || []

      if (roles.some(role => ADMIN_ROLES.includes(role)) && authStore.switchContext) {
        const isAdminRoute = window.location.pathname.includes('/tenant-admin/')
        if (isAdminRoute) {
          config.headers['x-switch-context'] = JSON.stringify(
            authStore.switchContext,
          )
        }
      }

      return config
    },
    error => Promise.reject(error),
  )
}
